<template>
    <div class="wrapper">
        <img src="logo.svg" width="300" class="logo"/>
        <h1>
            Login using your Walkbase account
        </h1>
        <form @submit.prevent="submit" id="login-form">
            <input id="username" name="username" v-model="username" type="email" placeholder="e-mail" :disabled="loading"/>
            <input id="password" name="password" v-model="password" type="password" placeholder="password" :disabled="loading"/>
            <input id="submit" type="submit" name="login" value="Login" :disabled="loading" v-if="!loading"/>
            <loading-icon v-if="loading" style="margin: .5rem auto;"></loading-icon>
        </form>
    </div>

</template>

<script>
  import LoadingIcon from '../components/LoadingIcon';
  const axios = require('axios');

  export default {
    name: 'login',
    components: {LoadingIcon},

    data() {
      return {
        username:   undefined,
        password: undefined,
        loading: false
      };
    },

    methods: {
      submit() {
        this.loading = true;
        axios.post(process.env.VUE_APP_API_BASE + process.env.VUE_APP_ENDPOINT_LOGIN, {
          username: this.username,
          password: this.password
        }, {
          'Content-Type': 'application/json'
        })
          .then((res) => {
            this.$store.dispatch('SET_USER', res.data);
            if (this.$route.query && this.$route.query.redirect) {
              this.$router.push(this.$route.query.redirect);
            } else {
              this.$router.push({name: 'dashboard'});
            }
          })
          .catch(() => {
            this.loading = false;
            this.$notify.error('Incorrect username or password.');
          });
      }
    }
  };
</script>

<style scoped lang="scss">

    .wrapper {
        height: 100%;
        width: 100%;
        padding: 2rem;
        display: flex;
        flex-flow: column;
        align-items: center;
        text-align: center;
    }

    .logo {
        margin-bottom: 2rem;
        max-width: 300px;
    }

    #login-form {
        margin: 3rem auto;
        display: flex;
        flex-flow: column;
    }

    input {
        padding: .75rem 1.25rem;
        margin: .5rem;
        border: 4px solid $brand-primary;
    }

    #submit {
        background-color: $brand-primary;
        color: #FFF;
        font-weight: bold;
        cursor: pointer;
    }

    #submit:disabled{
        background: grey;
    }

    #submit {
        width: fit-content;
        justify-self: flex-end;
    }

</style>